module.exports = __webpack_public_path__ + "kangping/img/buy-vip.f95fa1bb.png";